import React, { ReactNode } from 'react';
import styles from './assets/vendor-screen.module.scss';
import classNames from 'classnames';
import VendorsGrid from './components/VendorsGrid';
import { Paginated } from 'src/services/api-handlers/pagination';
import { QueryParams } from 'src/types/grid';
import CreateVendorButton from './components/CreateVendorButton';
import AdminLayout from 'src/components/layout/RoleLayout';
import { IVendor } from 'src/types/vendor';
import Loader from '../../../../../../components/Loader';

export interface StateProps {
    data: Paginated<IVendor>;
    inProgress: boolean;
}

export interface DispatchProps {
    getData: (params: QueryParams) => void;
}

export interface OwnProps {}

export interface Props extends StateProps, DispatchProps, OwnProps {}

class VendorsList extends React.Component<Props> {
    //componentDidMount() {}

    public render(): ReactNode {
        const { data, getData, inProgress } = this.props;

        return (
            <AdminLayout>
                <div className={`${classNames(styles.pageHeading)} ${'pageHeading'}`}>
                    <h2 className={`${classNames(styles.pageHeadingTitle)} ${'pageHeadingTitle'}`}>
                        VENDORS {data.totalCount ? '(' + data.totalCount + ')' : ''}
                    </h2>
                    <CreateVendorButton />
                </div>
                {inProgress ? <Loader /> : null}
                <div className={classNames(styles.list)}>
                    <VendorsGrid data={data} getData={getData} />
                </div>
            </AdminLayout>
        );
    }
}

export default VendorsList;
